import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { checkPaymentRequest } from "../store/modules/checkout/actions";
import { OrderData } from "../store/modules/order/types";

interface ICheckPaymentPollingInput {
    order?: OrderData;
    isOrderPage?: boolean;
}

const useCheckPaymentPolling = ({order, isOrderPage = false}: ICheckPaymentPollingInput) => {
    const dispatch = useDispatch();
    useEffect(() => {
        if (!order || (order.payment_detail?.[0]?.status !== "pending" && order.payment_detail?.[0]?.status !== "3dssecure")) {
            return;
        }

        const interval = setInterval(() => {
            if (order && order.payment_detail) {
                dispatch(
                    checkPaymentRequest({
                        transactionId: order.payment_detail[0].tef_nita as string,
                        isOrderPage,
                    })
                );
            }
        }, 10000);

        return () => clearInterval(interval);
    }, [dispatch, order, isOrderPage]);
};

export default useCheckPaymentPolling;